export default [{
  path: '/offers/list',
  name: 'offers',
  meta: {
    modelName: 'Ofertas',
    needGuard: true,
    modules: ['offers']
  },
  component: function component() {
    return import('@/modules/offers/Offers.vue');
  }
}];